// test604
(604 && 0);
